import 'jquery-validation'

var companyDetailMaxLength = gon.company_detail_max_length;

export default class CompanyWebEdit {

  constructor() {
    this.addCustomValidators();
    this.validateCfairsForm();
    this.showlength()
  }

  addCustomValidators() {
    if (!gon.error_messages) return;
    var parentClass = this;
    jQuery.validator.addMethod("hankaku", function(value, element) {
     return this.optional(element) || /^[\x20-\x7E]+$/.test(value);
    }, gon.error_messages.hankaku_eisu);

    jQuery.validator.addMethod("alphanum", function(value, element) {
     return this.optional(element) || /^([a-zA-Z0-9\x20]+)$/.test(value);
    }, gon.error_messages.alphanum);

    jQuery.validator.addMethod("maxlength_custom", function(value, element) {
     return this.optional(element) || parentClass.count_str(element) <= companyDetailMaxLength;
    }, gon.error_messages.less_than);
  }

  validateCfairsForm() {
    if (!gon.error_messages) return;
    jQuery(function() {
      jQuery("#js-cfairs-form").validate({

        rules: {
          'cfairs_company_web_edit[name]': {
            required: true
          },
          'cfairs_company_web_edit[name_en]': {
            required: true,
            hankaku: true
          },
          'cfairs_company_web_edit[establish_year]': {
            digits: true
          },
          'cfairs_company_web_edit[employee]': {
            hankaku: true
          },
          'cfairs_company_web_edit[telephone]': {
            hankaku: true
          },
          'cfairs_company_web_edit[url]': {
            hankaku: true
          },
          'cfairs_company_web_edit[email]': {
            hankaku: true
          },
          'company_edit[detail_desc]': {
            maxlength_custom: companyDetailMaxLength
          },

        },

        messages: {
          'cfairs_company_web_edit[name]': {
            required: gon.error_messages.name_blank
          },
          'cfairs_company_web_edit[name_en]': {
            required: gon.error_messages.name_en_blank,
            hankaku: gon.error_messages.hankaku_eisu
          },
          'cfairs_company_web_edit[establish_year]': {
            digits: gon.error_messages.establish_year_digits
          }
        }

      });
    });
  }

  showlength() {
    const textarea = document.getElementById("company_edit_detail_desc");
    const counter = document.getElementById("count_detail_desc");
    if (counter) {
      counter.innerHTML = this.count_str(textarea)
    }
  }

  count_str(control) {
    if (!control) {
      return '';
    }
    var text = control.value;
    var count = 0;
    for(var i = 0; i < text.length; i++) {
      var c = text.charAt(i);
      if (c < '\u007f') {
        count += 1;
      } else {
        count += 2;
      }
    }
    return count;
  }
}
